import { useEffect } from "react";
import { createKeyboardNavigation } from "./keyboard-navigation";

export const useKeyboardNavigation = ({
  saveButtonRef,
  clearButtonRef
}) => {
  useEffect(() => {
    const { setupTabNavigation } = createKeyboardNavigation({
      saveButtonRef,
      clearButtonRef
    });

    const cleanup = setupTabNavigation();
    return cleanup;
  }, [saveButtonRef, clearButtonRef]);

  return {};
};

